var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEraserAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4196 8.5394L10.248 17.711L6.289 13.752L15.4606 4.5804C15.7219 4.31906 16.0325 4.11205 16.3742 3.97133L21.0336 2.05274C21.2949 1.94516 21.5952 2.00522 21.795 2.205C21.9948 2.40479 22.0548 2.7051 21.9473 2.96635L20.0287 7.62579C19.888 7.96755 19.6809 8.27806 19.4196 8.5394Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4487 21.9983C5.06769 22.0171 4.68046 21.881 4.38947 21.59L2.40997 19.6105C1.86334 19.0639 1.86334 18.1777 2.40997 17.631L5.22836 14.8126L9.18736 18.7716L7.459 20.5H22C22.4142 20.5 22.75 20.8358 22.75 21.25C22.75 21.6642 22.4142 22 22 22H5.49982C5.48264 22 5.46559 21.9994 5.4487 21.9983Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraserAlt);
export default __webpack_public_path__ + "static/media/eraser-alt.bae2c26ef7949462d9041de400c6deac.svg";
export { ForwardRef as ReactComponent };